import { createVanIconComponent } from "./van"

const PlayCircle = createVanIconComponent("play-circle")
export default PlayCircle
